import { gql } from '@apollo/client';

export const QUERY = gql`
  query OrganizationFormFieldDefinitions($organization_id: Int!) {
    organizationFormFieldDefinitions(organizationId: $organization_id) {
      id
      name
      label
      locked
      required_default
      target
      type
      order
      options
      prefill
      active
      group
      organization_id
      options
      multiselect
      internal
      external_id
      external_type
    }
  }
`;
